import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { useCallback, useEffect } from "react";
export var PassiveScroll = function(param) {
    var onScroll = param.onScroll;
    var handleOnScroll = useCallback(function(event) {
        onScroll === null || onScroll === void 0 ? void 0 : onScroll(event);
    }, [
        onScroll
    ]);
    useEffect(function() {
        var _getWindow;
        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.addEventListener("scroll", handleOnScroll, {
            passive: true
        });
        return function() {
            var _getWindow;
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.removeEventListener("scroll", handleOnScroll);
        };
    }, [
        handleOnScroll
    ]);
    return null;
};
